module.exports = __webpack_public_path__ + "static/media/correct1.78e6dec9.mp3";